import { SectionType } from "@app/constants";
import HttpService from "./http.service";
import { AnswerRequest } from "@app/types/answer.type";

class _ExamAttemptService {
  public completeSection(examAttemptId: number, type: SectionType) {
    return HttpService.post(
      `/exam-attempts/${examAttemptId}/complete-section`,
      {
        body: {
          sectionType: type,
        },
      }
    );
  }

  public sendAnswer(testId: number, questionId: number, answer: any) {
    return HttpService.post(`/exam-attempts/${testId}/answers`, {
      body: {
        answers: [
          {
            questionId,
            data: {
              textValue: answer,
            },
          },
        ],
      },
    });
  }

  public sendAnswers(testId: number, answers: AnswerRequest[]) {
    return HttpService.post(`/exam-attempts/${testId}/answers`, {
      body: {
        answers,
      },
    });
  }
}

export default new _ExamAttemptService();
